/**
 * ACCESS-1 — the signed-in user's own effective access, used to decide what the
 * nav shows (e.g. the Library module renders only for staff who've been granted
 * Library access, or for a Super Admin who holds everything implicitly).
 *
 * This is a UI convenience ONLY — the server still enforces every capability on
 * every request from the database, so hiding a nav item is never the security
 * boundary. GET /capabilities/me returns e.g. { CAP_FEES: 'FULL' }; an absent
 * key means "no access". A Super Admin gets every key at 'FULL'.
 */
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export type CapabilityKey = 'CAP_LIBRARY' | 'CAP_FEES';
export type MyCapabilities = Partial<Record<CapabilityKey, 'VIEW' | 'FULL'>>;

export const MY_CAPABILITIES_QUERY_KEY = ['capabilities', 'me'] as const;

export function useMyCapabilities() {
  return useQuery({
    queryKey: MY_CAPABILITIES_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<{ data: MyCapabilities }>('/capabilities/me');
      return res.data?.data ?? {};
    },
    staleTime: 5 * 60 * 1000,
  });
}
